import request from "@/utils/request";

function publicOptionGetLatestUgcData(data){   // 正负面数据
    return request({
        url: 'publicOption/getLatestUgcData',
        method: 'POST',
        data
    })
}

function publicOptionGetSourceRate(data){    // 信源占比图
    return request({
        url: 'publicOption/getSourceRate',
        method: 'POST',
        data
    })
}

function publicOptionGetLatestNews(data){   // 最新纸媒报道
    return request({
        url: 'publicOption/getLatestNews',
        method: 'POST',
        data
    })
}

function publicOptionGetLatestTouristComments(data){   // 最新游客评价
    return request({
        url: 'publicOption/getLatestTouristComments',
        method: 'POST',
        data
    })
}

function publicOptionGetPublicOptionRiskIndex(data){   //舆情风险指数
    return request({
        url: 'publicOption/getPublicOptionRiskIndex',
        method: 'POST',
        data
    })
}

function publicOptionGetPublicOptionDataTrend(data) {   // 舆情数据趋势折线图
    return request({
        url: 'publicOption/getPublicOptionDataTrend',
        method: 'POST',
        data
    })
}

function datacenterGetemotionrate(data){    // 情绪占比图
    return request({
        url: 'datacenter/getemotionrate',
        method: 'POST',
        data
    })
}

function datacenterGetheatedtopic(data){   // 词云图
    return request({
        url: 'datacenter/getheatedtopic',
        method: 'POST',
        data
    })
}

function publicOptionExportPublicData(data){  //数据导出
    return request({
        url: 'publicOption/exportPublicData?startTime=' + data.startTime + '&endTime=' + data.endTime,
        method: 'GET',
        data
    })
}


export{
    publicOptionGetLatestUgcData,
    publicOptionGetSourceRate,
    publicOptionGetLatestNews,
    publicOptionGetLatestTouristComments,
    publicOptionGetPublicOptionRiskIndex,
    publicOptionGetPublicOptionDataTrend,
    datacenterGetemotionrate,
    datacenterGetheatedtopic,
    publicOptionExportPublicData
}
